import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppCommon2Module } from '@common2/common.module';

import { GrikySkillsAdminRoutingModule } from './griky-skills-admin-routing.module';
import { GsAdminShellComponent } from './pages/gs-admin-shell/gs-admin-shell.component';
import { GsSettingsPageComponent } from './pages/gs-settings-page/gs-settings-page.component';

@NgModule({
    declarations: [
        GsAdminShellComponent,
        GsSettingsPageComponent,
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        AppCommon2Module,
        GrikySkillsAdminRoutingModule,
    ],
})
export class GrikySkillsAdminModule {}
